var ClinicSummaryRequest = /** @class */ (function () {
    function ClinicSummaryRequest(_a) {
        var PublicToken = _a.PublicToken;
        this.Action = 'getclinicsummary';
        this.PublicToken = PublicToken;
    }
    return ClinicSummaryRequest;
}());
export { ClinicSummaryRequest };
